import { defineMessages } from 'react-intl';

export default defineMessages({
    FirstNameLabel: {
        id: 'cep.accountPage.accountDetails.FirstNameLabel',
        defaultMessage: 'First Name'
    },
    LastNameLabel: {
        id: 'cep.accountPage.accountDetails.LastNameLabel',
        defaultMessage: 'Last Name'
    },
    AddressLabel: {
        id: 'cep.accountPage.accountDetails.AddressLabel',
        defaultMessage: 'Address'
    },
    CityLabel: {
        id: 'cep.accountPage.accountDetails.CityLabel',
        defaultMessage: 'City'
    },
    PostcodeLabel: {
        id: 'cep.accountPage.accountDetails.PostcodeLabel',
        defaultMessage: 'Postcode'
    },
    EmailLabel: {
        id: 'cep.accountPage.accountDetails.EmailLabel',
        defaultMessage: 'Email'
    },
    HomePhoneLabel: {
        id: 'cep.accountPage.accountDetails.HomePhoneLabel',
        defaultMessage: 'Home phone'
    },
    MobilePhoneLabel: {
        id: 'cep.accountPage.accountDetails.MobilePhoneLabel',
        defaultMessage: 'Mobile phone'
    },
    ChangeEmailLabel: {
        id: 'cep.accountPage.accountDetails.ChangeEmailLabel',
        defaultMessage: 'Change email'
    },
    ChangePasswordLabel: {
        id: 'cep.accountPage.accountDetails.ChangePasswordLabel',
        defaultMessage: 'Change password'
    },
    ChangeCommPrefLabel: {
        id: 'cep.accountPage.accountDetails.ChangeCommPrefLabel',
        defaultMessage: 'Change communication preferences'
    }
});
